module.exports = __webpack_public_path__ + "front/img/s4.b1aa1235.png";